import './VideoFinalStep.css';
import React, { useState } from 'react';
import LazyPicture from '../../atoms/LazyPicture';
import { canUseDOM, get } from '../../../utils';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../../atoms/RouterLink';
import { LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR, LOCAL_STORAGE_KEY_VIDEO_COLLECTION_DATA } from '../constants';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SocialNav from '../../atoms/SocialNav/SocialNav';
import { loaderToggle } from '../../../utils/setUserCookie';
import { ReactComponent as EmailMessageIcon } from '../../../resources/icons/email-message.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const VideoFinalStep = _ref => {
  let {
    fields,
    params,
    collectedData,
    rtl,
    analytics
  } = _ref;
  const accountDictionaryValues = get(fields, 'data.accountDictionary.dictionaryValues') || [];
  const mapAccountDictionary = accountDictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const [formResponseError, setFormResponseError] = useState('');
  const [_, setDisableSubmit] = useState(false);
  const subtitle = get(fields, 'data.configuration.subtitle.jss.value');
  const imageIcon = get(fields, 'data.configuration.imageIcon.jss.value.src');
  const imageIconAlt = get(fields, 'data.configuration.imageIcon.jss.value.alt');
  const iconCode = get(fields, 'data.configuration.imageIconCode.jss.value');
  const paragraphText = get(fields, 'data.configuration.paragraphText.jss');
  const navigationLink = get(fields, 'data.configuration.navigationLink.jss.value.href');
  const navigationLabel = get(fields, 'data.configuration.navigationLabel.jss.value');
  const navigationToRegistrationLink = get(fields, 'data.configuration.registerLink.jss.value.href');
  const navigationToRegistrationLabel = get(fields, 'data.configuration.registerLabelLink.jss.value');
  const facebookAppId = get(fields, 'data.authorisationApisetting.facebookAppId.jss.value');
  const googleClientId = get(fields, 'data.authorisationApisetting.googleClientId.jss.value');
  const socialFBText = mapAccountDictionary.get('Facebook');
  const socialGlText = mapAccountDictionary.get('Google');
  const formErrorNetworkOrApiIssue = mapAccountDictionary.get('LoginApiFailError');
  const registerTextLabel = mapDictionary.get('RegisterLabel');
  const addKeysToLocalStorageForLoginHandler = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR, window.location.pathname);
    localStorage.setItem(LOCAL_STORAGE_KEY_VIDEO_COLLECTION_DATA, JSON.stringify(collectedData));
    return null;
  };
  const sendAnalytics = btnLabel => {
    tealiumClickFunc(tealiumMergeClickData(analytics['LoginStepButtonClickAnalytics'], params), btnLabel);
  };
  const successFunction = () => {
    if (canUseDOM) {
      if (addKeysToLocalStorageForLoginHandler()) return;
      const linkToVideoScriptGenerator = localStorage.getItem(LOCAL_STORAGE_KEY_LINK_TO_VIDEO_SCRIPT_GENERATOR) || null;
      if (linkToVideoScriptGenerator) {
        window.location.href = linkToVideoScriptGenerator;
        return true;
      }
      return false;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "titleWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titleImage"
  }, iconCode ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: iconCode
    }
  }) : /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: imageIcon
  }), /*#__PURE__*/React.createElement("img", {
    src: imageIcon,
    alt: imageIconAlt,
    title: imageIconAlt
  }))), /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, subtitle)), /*#__PURE__*/React.createElement(RichText, {
    className: "description",
    tag: "p",
    field: paragraphText
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(GoogleOAuthProvider, {
    clientId: googleClientId
  }, /*#__PURE__*/React.createElement(SocialNav, {
    buttons: [{
      sm: 'gp',
      text: socialGlText
    }, {
      sm: 'fb',
      text: socialFBText
    }],
    showError: errorMessage => setFormResponseError(errorMessage),
    ApiError: formErrorNetworkOrApiIssue,
    successFunction: successFunction,
    loadingFunc: state => loaderToggle(state, setDisableSubmit),
    facebookAppId: facebookAppId,
    googleClientId: googleClientId,
    analytics: {
      params
    },
    customAnalyticsFunc: sendAnalytics,
    className: "col-12 col-md-8 col-xl-6",
    isBtnContainerHorizontal: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-4 col-xl-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md col-lg-12 col-xl-6"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: `${window.location.origin}${navigationLink}`,
    onClick: () => {
      addKeysToLocalStorageForLoginHandler();
      sendAnalytics(navigationLabel);
    },
    className: "btn btn-primary loginBtn",
    openInSameTab: true
  }, !rtl ? /*#__PURE__*/React.createElement(EmailMessageIcon, null) : null, /*#__PURE__*/React.createElement("span", {
    className: "navigationLabelText"
  }, navigationLabel), rtl ? /*#__PURE__*/React.createElement(EmailMessageIcon, null) : null))))), /*#__PURE__*/React.createElement("div", {
    className: "registrationTextAndLinkWrapper"
  }, /*#__PURE__*/React.createElement("p", {
    className: "registrationTextLabel"
  }, registerTextLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: `${window.location.origin}${navigationToRegistrationLink}`,
    onClick: () => {
      addKeysToLocalStorageForLoginHandler();
      sendAnalytics(navigationToRegistrationLabel);
    },
    className: "btn btn-tertiary registrationBtnLink",
    openInSameTab: true
  }, navigationToRegistrationLabel)), formResponseError && formResponseError.length ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-error-response"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, formResponseError)))) : null);
};
VideoFinalStep.displayName = "VideoFinalStep";
export { VideoFinalStep };
const commonStyles = "c1sehob8";
const rtlStyles = "r1fq3r02";
const ltrStyles = "l111y62y";